/**
 * Version comparison utilities.
 *
 * Compares semver-style version strings (major.minor.patch).
 * Used by useVersionCheck to determine if an update is available.
 */

/**
 * Parse a version string like "2.1.3" into [major, minor, patch].
 * Returns [0, 0, 0] for invalid input.
 */
export function parseVersion(version: string): [number, number, number] {
  const parts = version.split(".").map(Number)
  return [parts[0] ?? 0, parts[1] ?? 0, parts[2] ?? 0]
}

/**
 * Returns true if `latest` is a newer version than `current`.
 *
 * @example
 * isNewerVersion("2.0.0", "2.1.0") // true
 * isNewerVersion("2.1.0", "2.1.0") // false
 * isNewerVersion("3.0.0", "2.9.9") // false
 */
export function isNewerVersion(current: string, latest: string): boolean {
  const [cMaj, cMin, cPatch] = parseVersion(current)
  const [lMaj, lMin, lPatch] = parseVersion(latest)

  if (lMaj !== cMaj) return lMaj > cMaj
  if (lMin !== cMin) return lMin > cMin
  return lPatch > cPatch
}
